export interface MessageField {
  key: string;
  value: string;
}

export interface ContactInquiry {
  id: number;
  created_at: string;
  project_id: string;
  subject: string | null;
  email: string | null;
  message: string | null;
  name?: string | null;
  company_name?: string | null;
  phone?: string | null;
}

function stringifyValue(value: unknown): string {
  if (value === null || value === undefined) return '-';
  if (Array.isArray(value)) return value.map((item) => stringifyValue(item)).join(', ');
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

/**
 * Parse the `message` column (a JSON string of form field key/value pairs)
 * into a readable ordered list of fields.
 */
export function parseMessageFields(message: string | null | undefined): MessageField[] {
  if (!message || !message.trim()) return [];
  let parsed: unknown;
  try {
    parsed = JSON.parse(message);
  } catch {
    return [{ key: 'message', value: message }];
  }
  if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
    return Object.entries(parsed as Record<string, unknown>).map(([key, value]) => ({
      key,
      value: stringifyValue(value),
    }));
  }
  return [{ key: 'message', value: stringifyValue(parsed) }];
}

/**
 * Build a short one-line summary from the parsed message fields.
 */
export function summarizeMessage(message: string | null | undefined, max = 3): string {
  const fields = parseMessageFields(message);
  if (fields.length === 0) return '-';
  return fields
    .slice(0, max)
    .map((field) => `${field.key}: ${field.value}`)
    .join(' / ');
}